module.exports = {"children":false,"jsPrefix":"Img","sizes":{"thumb":50,"min":200,"max":1000,"inc":200},"quality":{"image":40,"thumb":80},"thumbBlurLarge":2,"thumbBlurSmall":1,"location":"./src/content/images"}


//////////////////
// WEBPACK FOOTER
// ./images.config.json
// module id = cM4a
// module chunks = 1